<template>
  <div class="page-blogs">

    <div class="columns">
      <div class="column content" style="margin-bottom:15px;">
        <p class="title">Blogs</p>
        <p class="subtitle">Describing Blogs</p>
      </div>
    </div>

    <div class="box">
      <article class="media">
        <div class="media-left">
          <figure class="image is-64x64">
            <img src="http://bulma.io/images/placeholders/128x128.png" alt="Image">
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p>
              <strong>John Smith</strong> <small>@johnsmith</small> <small>31m</small>
              <br>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis.
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item" style="padding:5px;padding-left:0px;">
                <span class="icon is-small"><i class="material-icons">reply</i></span>
              </a>
              <a class="level-item" style="padding:5px;">
                <span class="icon is-small"><i class="material-icons">share</i></span>
              </a>
              <a class="level-item" style="padding:5px;">
                <span class="icon is-small"><i class="material-icons">favorite</i></span>
              </a>
            </div>
          </nav>
        </div>
      </article>
    </div>

    <section class="section">
      <div>
        <slick ref="slick" :options="slickOptions">
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
          <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
        </slick>
      </div>
    </section>

    <div class="columns">
    <div class="column content">
    <div class="tabs">
      <ul>
        <li class="is-active"><a>Featured</a></li>
        <li><a>Most Popular</a></li>
        <li><a>Most Viewed</a></li>
      </ul>
    </div>
    </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child">
          <div class="card">
            <div class="card-image">
              <figure class="image is-4by3">
                <img src="http://bulma.io/images/placeholders/1280x960.png" alt="Image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-64x64">
                    <img src="http://bulma.io/images/placeholders/96x96.png" alt="Image">
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">John Smith</p>
                  <p class="subtitle is-6">@johnsmith</p>
                </div>
              </div>

              <div class="content">
                This is a card design, no lorem ipsum anymore! consectetur adipiscing elit.
                Phasellus nec iaculis mauris. <a>@bulmaio</a>.
                <a>#css</a> <a>#responsive</a>
                <br>
                <small>11:09 PM - 1 Jan 2016</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">Two</p>
          <p class="subtitle">Describing Two</p>
        </div>
      </div>
      <div class="tile is-6 is-parent">
        <div class="tile is-child box">
          <p class="title">Three</p>
          <p class="subtitle">Describing Three</p>
        </div>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-6 is-parent">
        <div class="tile is-child box">
          <p class="title">Four</p>
          <p class="subtitle">Describing Four</p>
        </div>
      </div>
      <div class="tile">
        <div class="tile is-parent">
          <div class="tile is-child box">
            <p class="title">Five</p>
            <p class="subtitle">Describing Five</p>
          </div>
        </div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">Six</p>
          <p class="subtitle">Describing Six</p>
        </div>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">Seven</p>
          <p class="subtitle">Describing Seven</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'
export default {
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }
        ]
      },
      images: [
        {
          title: 'The best image1',
          src: './src/assets/sports.1.jpg',
          desc: '',
          other: ''
        },
        {
          title: 'The best image2',
          src: './src/assets/sports.2.jpg',
          desc: '',
          other: ''
        },
        {
          title: 'The best image3',
          src: './src/assets/sports.3.jpg',
          desc: '',
          other: ''
        },
        {
          title: 'The best image4',
          src: './src/assets/sports.4.jpg',
          desc: '',
          other: ''
        }
      ]
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      this.$refs.slick.reSlick()
    }
  },
  created () {
    console.log('created Blogs.vue')
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-blogs {
  background-color: #ccc;
}

/*.VueCarousel {
  position: relative;
}
.VueCarousel-pagination {
  position: absolute;
  bottom: 10px;
  z-index: 100;
}*/

</style>



// WEBPACK FOOTER //
// Blogs.vue?3faee206